export default "__VITE_ASSET__CzfJ0hhS__"